import React from 'react';
import {
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Divider,
} from '@mui/material';
import { CloseRounded as CloseRoundedIcon } from '@mui/icons-material';
import { COLOR } from '@src/styles/color';
import Typography from '../Typography';
import { StyledDialog } from './index.style';

const CommonDialog = ({
  icon,
  fullWidth = false,
  open,
  onClose,
  title,
  contentComponent,
  actionComponent,
  showClose = true,
  renderCloseIcon,
  disableClose = false,
  disableAutoClose = false,
  showDivider = true,
  width,
  renderTitle,
  styleTitle,
  hideTitle = false,
  styleContent,
  showBlurBackground,
  ...rest
}) => (
  <StyledDialog
    open={open}
    onClose={(event, reason) => {
      if (
        disableAutoClose &&
        (reason === 'backdropClick' || reason === 'escapeKeyDown')
      ) {
        return;
      }
      onClose?.(event, reason);
    }}
    fullWidth={fullWidth}
    width={width}
    paddingTitle={styleTitle?.paddingTitle}
    heightTitle={styleTitle?.height}
    styleCloseIcon={styleTitle?.closeIcon}
    styleContent={styleContent}
    showBlurBackground={showBlurBackground}
    {...rest}
  >
    {!hideTitle && (
      <DialogTitle className="dialog-title">
        {icon && icon}
        {renderTitle ||
          (title && (
            <Typography variant="body-20-bold" color={COLOR.darkGray}>
              {title}
            </Typography>
          ))}
      </DialogTitle>
    )}
    {renderCloseIcon ||
      (showClose && (
        <IconButton
          disabled={disableClose}
          className="close-icon"
          onClick={onClose}
          aria-label="close"
        >
          <CloseRoundedIcon />
        </IconButton>
      ))}
    {showDivider && <Divider />}
    <DialogContent className="dialog-content">{contentComponent}</DialogContent>
    {actionComponent && (
      <DialogActions className="dialog-actions">
        {actionComponent}
      </DialogActions>
    )}
  </StyledDialog>
);

export default CommonDialog;
